import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface CreateRunFlowTaskParams {
  readonly scheduleId: string;
  readonly flowId: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export class CreateRunFlowTaskRequest extends Request<CreateRunFlowTaskParams, IResult> {
  constructor(params: CreateRunFlowTaskParams) {
    super('createRunFlowTask', params);
  }
}
